import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Loader } from '@hivebrite/design-system/Loader';
import { zIndices } from '@hivebrite/design-system/Theme';

export const LockScreen = () => (
  <LoaderWrapper>
    <Box
      position="fixed"
      top="50%"
      left="50%"
      translate="transform(-50%, -50%)"
    >
      <Loader size={24} />
    </Box>
  </LoaderWrapper>
);

const LoaderWrapper = styled(Box)`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  user-select: none;
  z-index: ${zIndices.pinned};
  display: block;

  div {
    opacity: 0.8;
    pointer-events: none;
  }
`;
